import { connect } from 'react-redux';
import PlayoutsLabel from '../../components/step2_settings/supporting/PlayoutsLabel';

const mapStateToProps = ({ display }) => ({
  programmatic: display.programmatic,
  isGuaranteed: display.isGuaranteed
});

export default connect(mapStateToProps)(PlayoutsLabel);
